import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/App";
import { DevBanner } from "@/components/DevBanner";
import { env } from "@/config/environment";
import "@/styles/theme.css";

document.title = env.isDev ? 'DEV ADMIN — Previs Pro' : 'PRODUCTION ADMIN — Previs Pro';

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <DevBanner />
    <App />
  </StrictMode>
);
